<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="3" md="3">
                <v-text-field 
                    v-model="editData.team_licensed_employees" 
                    label="How Many Licensed Employees">
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field 
                    v-model="editData.team_employee_licenses" 
                    label="Employee Licenses">
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field 
                    v-model="editData.team_employee_designations" 
                    label="Employee Designations">
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field 
                    v-model="editData.team_unlicensed_employees" 
                    label="How Many Unlicensed Employees">
                </v-text-field>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'TeamInfo',
        props: [
            'editData'
        ],
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/TeamInfo.vue